import React from "react";
import PropTypes from "prop-types";
import "./progress-bar.component.scss";
class ProgressBar extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    /**
     * Tiempo de animación en segundos posibles valores:
     * [ 1 | 1_5 | 1_75 | 2 | 2_5 | 3 | 4 | 5 ]
     * = 1s, 1.5s, 1.75, ...
     */
    aniTime: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object
  };
  static defaultProps = {
    active: false,
    aniTime: "3",
    className: ""
  };
  render() {
    const { active, aniTime, className, style } = this.props;
    return (
      <div
        className={`
        progress-bar${active ? " progress-bar--active" : ""}${
          className ? " " + className : ""
        }`}
        style={style}
      >
        <div className={`bar${active ? ` bar--animation-${aniTime}s` : ""}`} />
      </div>
    );
  }
}
export default ProgressBar;
